// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"810a16c6","377":"56833b58","417":"57c56326","467":"8c7a28d3","626":"e5e40771","870":"1dd102e0"}[chunkId] + ".js";
};